<template>
  <RevCard class="p-16">
    <ul class="flex flex-col list-none gap-32 md:flex-row md:gap-16">
      <FeatureHighlightItem
        :description="i18n(translations.savingsDescription)"
        :icon="IconMoney"
        :title="i18n(translations.savingsTitle)"
      />

      <FeatureHighlightItem
        :description="i18n(translations.flexibilityDescription)"
        :icon="IconBill"
        :title="i18n(translations.flexibilityTitle)"
      />

      <FeatureHighlightItem
        :description="i18n(translations.unlockedDescription)"
        :icon="IconLockUnlocked"
        :title="i18n(translations.unlockedTitle)"
      />
    </ul>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { IconBill } from '@ds/icons/IconBill'
import { IconLockUnlocked } from '@ds/icons/IconLockUnlocked'
import { IconMoney } from '@ds/icons/IconMoney'

import translations from './FeatureHighlights.translations'
import FeatureHighlightItem from './components/FeatureHighlightItem/FeatureHighlightItem.vue'

const i18n = useI18n()
</script>
